import React from "react";

const Pagination = ({ page, totalPages, handlePageClick }) => {
  return (
    <>
      <nav aria-label="Page navigation">
        <ul className="pagination flex justify-content-end">
          {/* First Page */}
          <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
            <button className="page-link" onClick={() => handlePageClick(1)}>
              First
            </button>
          </li>

          {/* Previous */}
          <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => handlePageClick(page - 1)}
            >
              Previous
            </button>
          </li>

          {/* Page Number Buttons in chunks */}
          {(() => {
            const pageNumbers = [];
            const maxPagesToShow = 5;
            const startPage =
              Math.floor((page - 1) / maxPagesToShow) * maxPagesToShow + 1;
            const endPage = Math.min(
              startPage + maxPagesToShow - 1,
              totalPages,
            );

            for (let i = startPage; i <= endPage; i++) {
              pageNumbers.push(
                <li
                  key={i}
                  className={`page-item ${page === i ? "active" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(i)}
                  >
                    {i}
                  </button>
                </li>,
              );
            }
            return pageNumbers;
          })()}

          {/* Next */}
          <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => handlePageClick(page + 1)}
            >
              Next
            </button>
          </li>

          {/* Last Page */}
          <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => handlePageClick(totalPages)}
            >
              Last
            </button>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default Pagination;
